module.exports = __webpack_public_path__ + "img/KWT.30e9c89e.svg";